import { render } from "./setMailing.vue?vue&type=template&id=ddb948d6"
import script from "./setMailing.vue?vue&type=script&lang=js"
export * from "./setMailing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__